import { render, staticRenderFns } from "./WxWorkList.vue?vue&type=template&id=0d284860&"
import script from "./WxWorkList.vue?vue&type=script&lang=js&"
export * from "./WxWorkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports